import UserService from "./user.service";

/**
 * Calculate distance between two points in kilometers
 */
const calcDistance = (lat1, lat2, lon1, lon2) => {
  lat1 = (lat1 * Math.PI) / 180;
  lat2 = (lat2 * Math.PI) / 180;
  lon1 = (lon1 * Math.PI) / 180;
  lon2 = (lon2 * Math.PI) / 180;
  const R = 6371; // km
  const x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
  const y = lat2 - lat1;
  const d = Math.sqrt(x * x + y * y) * R;
  return d;
};

/**
 * Find places within specified distance of route points and fetch their detailed content
 * @param {Array} routePoints - Array of route points with lat() and lng() methods
 * @param {Object} minimalData - Minimal data object with 'data' property containing places
 * @param {number} maxDistance - Maximum distance in km (default: 15)
 * @param {Function} onSuccess - Success callback with fetched items
 * @param {Function} onError - Error callback
 */
export const findAndFetchRouteMarkers = (routePoints, minimalData, maxDistance = 15, onSuccess, onError) => {
  const markersinside = [];
  const idstocatch = [];
  
  routePoints.forEach((points) => {
    for (const element in minimalData["data"]) {
      const distance = calcDistance(
        minimalData["data"][element].lat,
        points.lat(),
        minimalData["data"][element].lng,
        points.lng()
      );

      if (distance <= maxDistance) {
        if (markersinside.indexOf(minimalData["data"][element].id) === -1) {
          markersinside.push(minimalData["data"][element].id);
          idstocatch.push(minimalData["data"][element].id);
        }
      }
    }
  });

  if (idstocatch.length > 0) {
    UserService.getIDsContent(idstocatch.join(",")).then(
      (response) => {
        if (onSuccess) onSuccess(response.data.data, idstocatch);
      },
      (error) => {
        if (onError) onError(error);
      }
    );
  } else {
    // No items found, return empty array
    if (onSuccess) onSuccess([], []);
  }
};

/**
 * Utility function to fetch minimal data with conditional filter passing
 * @param {Object} filter - Current filter object
 * @param {Object} defaultFilter - Default filter values
 * @param {Function} onSuccess - Success callback
 * @param {Function} onError - Error callback
 */
export const fetchMinimalDataWithFilter = (filter, defaultFilter, onSuccess, onError) => {
  const isFilterSet = (currentFilter, defaultFilterValues) => {
    const fieldsToCheck = [
      'features', 'gespanneErlaubt', 'interests', 'noofpitches', 
      'price', 'typePitch', 'typePitchEntsorgung', 'typeService', 'underground', 
      'vehicle_length', 'voucher'
    ];
    
    return fieldsToCheck.some(field => 
      JSON.stringify(currentFilter[field]) !== JSON.stringify(defaultFilterValues[field])
    );
  };
  
  const filterParams = isFilterSet(filter, defaultFilter) ? filter : undefined;
  
  UserService.getMinimalData(filterParams).then(
    (minData) => {
      if (onSuccess) onSuccess(minData);
    },
    (error) => {
      if (onError) onError(error);
    }
  );
};

/**
 * Check if any filter values differ from default values
 * @param {Object} filter - Current filter object
 * @param {Object} defaultFilter - Default filter values
 * @returns {boolean} - True if any filter is set
 */
export const isFilterSet = (filter, defaultFilter) => {
  const fieldsToCheck = [
    'features', 'gespanneErlaubt', 'interests', 'noofpitches', 
    'price', 'typePitch', 'typePitchEntsorgung', 'typeService', 'underground', 
    'vehicle_length', 'voucher'
  ];
  
  return fieldsToCheck.some(field => 
    JSON.stringify(filter[field]) !== JSON.stringify(defaultFilter[field])
  );
};